/* eslint-disable no-bitwise */
import { connect } from 'react-redux';
import { find, get } from 'lodash';

export const withValue = connect(
  (_, { input, meta, dispatch, defaultValue, ...other }) => ({
    defaultValue,
    ...other,
    value: input.value || defaultValue,
    tip: meta.touched && typeof meta.error !== 'undefined' ? meta.error : '',
    isError: meta.touched && typeof meta.error !== 'undefined',
    onChange: (value) => input.onChange(get(value, 'value', value)),
  }),
);

export const withCheckedValue = connect(
  (_, { input, meta, dispatch, defaultValue, ...other }) => ({
    ...other,
    value: input.value,
    tip: meta.touched && typeof meta.error !== 'undefined' ? meta.error : '',
    isError: meta.touched && typeof meta.error !== 'undefined',
    checked: defaultValue ? input.value === defaultValue : Boolean(input.value),
    onChange: (checked) =>
      input.onChange(defaultValue ? checked && defaultValue : checked),
  }),
);

const getBinaryValue = (options, value) => {
  return find(options, (o) => value & o.value);
};

export const withBinaryValue = connect(
  (
    _,
    { input, meta, dispatch, defaultValue, options, name, rowData, ...other },
  ) => ({
    ...other,
    options,
    defaultValue,
    value: getBinaryValue(options, input.value) || defaultValue,
    tip: meta.touched && typeof meta.error !== 'undefined' ? meta.error : '',
    isError: meta.touched && typeof meta.error !== 'undefined',
    rowData,
    name,
    onChange: (selected) => {
      const prevSelected = getBinaryValue(options, input.value);
      const prevValue = prevSelected ? prevSelected.value : defaultValue;
      const valueWithoutPrev = input.value - prevValue;

      input.onChange(selected.value + valueWithoutPrev);
    },
  }),
);

export const withCheckedBinaryValue = connect(
  (_, { input, meta, dispatch, defaultValue, ...other }) => ({
    ...other,
    defaultValue,
    value: input.value,
    tip: meta.touched && typeof meta.error !== 'undefined' ? meta.error : '',
    isError: meta.touched && typeof meta.error !== 'undefined',
    checked: !!(input.value & defaultValue),
    onChange: (checked) => {
      const value = Number(input.value);

      input.onChange(checked ? value + defaultValue : value - defaultValue);
    },
  }),
);
